import { useCallback } from 'react';
import CurrencyInput from '../common/CurrencyInput';
import DemandStudioProviderNameCell from './DemandStudioProviderNameCell';
import useMedicalBillProviderNameCell from '../../hooks/useMedicalBillProviderNameCell';
import { MEDICAL_BILL_FIELD } from '../../utils/enum';
import { normalizeMedicalBillAmountForInput } from '../../utils/medicalBillUtils';
import {
  providerCellClasses,
  tdBaseClasses,
  totalInputClasses,
} from './demandStudioMedicalBillsClasses';

const DemandStudioMedicalBillsRow = ({ clientId, records, rowIndex, onFieldChange }) => {
  const record = records[rowIndex];

  const commitProviderName = useCallback(
    (value) =>
      onFieldChange?.({
        clientId,
        rowIndex,
        field: MEDICAL_BILL_FIELD.PROVIDER_NAME,
        value,
      }),
    [clientId, rowIndex, onFieldChange]
  );

  const { draftProviderName, validationError, handleChange, handleBlur, handleKeyDown } =
    useMedicalBillProviderNameCell({ records, rowIndex, onCommit: commitProviderName });

  return (
    <tr>
      <td className={providerCellClasses}>
        <DemandStudioProviderNameCell
          value={draftProviderName}
          error={validationError}
          onChange={handleChange}
          onBlur={handleBlur}
          onKeyDown={handleKeyDown}
        />
      </td>
      <td className={tdBaseClasses}>
        <CurrencyInput
          step="0.01"
          min="0"
          className={totalInputClasses}
          value={normalizeMedicalBillAmountForInput(record?.totalBillAmount)}
          onChange={(e) =>
            onFieldChange?.({
              clientId,
              rowIndex,
              field: MEDICAL_BILL_FIELD.TOTAL_AMOUNT,
              value: e.target.value,
            })
          }
        />
      </td>
    </tr>
  );
};

export default DemandStudioMedicalBillsRow;
